import { FunctionComponent as F } from "react";
import { timestampToSeconds } from "../../utils/string";
import { Box } from "@mui/material";
import SpielsTable from "../Refs/SpielsTable";
import { IValue } from "../Refs/RefsTable";



interface IProps
{
  record: IValue
}

const Vimeo: F<IProps> = (props: IProps) =>
{
  const startSeconds = timestampToSeconds(props.record.startTime);

  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ display: 'flex' }}>
        <SpielsTable record={props.record}/>
      </Box>
      <Box sx={{ display: 'flex', textAlign: 'right' }}>
        <iframe
          src={props.record.url + "?dnt=true&#t=" + startSeconds + "s"}
          width='420'
          height='236'
          frameBorder='0'
          allowFullScreen
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          title='Embedded Vimeo' />
      </Box>
    </Box>);
};

export default Vimeo;
